import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { RPC_URLS } from "./networks";
import { ALL_SUPPORTED_CHAIN_IDS, ALL_UNSUPPORTED_CHAIN_IDS } from "./chains";

const injected = new InjectedConnector({
  supportedChainIds: [...ALL_SUPPORTED_CHAIN_IDS, ...ALL_UNSUPPORTED_CHAIN_IDS],
});

const walletconnect = new WalletConnectConnector({
  rpc: RPC_URLS,
  bridge: "https://bridge.walletconnect.org",
  qrcode: true,
});

export const connectors = {
  injected: injected,
  walletConnect: walletconnect,
};

export enum ConnectionType {
  INJECTED = "INJECTED",
  // COINBASE_WALLET = "COINBASE_WALLET",
  WALLET_CONNECT = "WALLET_CONNECT",
  // NETWORK = "NETWORK",
  // GNOSIS_SAFE = "GNOSIS_SAFE",
}

// const CONNECTIONS = [injected, walletconnect];

export function getConnection(c: ConnectionType) {
  //   if (c instanceof ConnectionType) {
  //     const connection = CONNECTIONS.find(
  //       (connection) => connection.connector === c
  //     );
  //     if (!connection) {
  //       throw Error("unsupported connector");
  //     }
  //     return connection;
  //   } else {
  switch (c) {
    case ConnectionType.INJECTED:
      return injected;
    // case ConnectionType.COINBASE_WALLET:
    //   return coinbaseWalletConnection;
    case ConnectionType.WALLET_CONNECT:
      return walletconnect;
    // case ConnectionType.NETWORK:
    //   return networkConnection;
    // case ConnectionType.GNOSIS_SAFE:
    //   return gnosisSafeConnection;
  }
  // }
}
